<template>
  <div class="km-module">
    <div
      ref="themeCustomizer"
      class="theme-customizer position-fixed end-0 top-0 bottom-0 h-100"
      :class="[isShowThemeCustomizer ? 'show' : 'hide']"
    >
      <div
        class="position-absolute top-50 start-0 theme-customizer-toggle"
        @click.prevent="isShowThemeCustomizer = !isShowThemeCustomizer"
      >
        <i class="km-icon-setting align-middle"></i>
      </div>
      <div class="h-100 theme-customizer-content">
        <h4 class="mb-0 theme-customizer-title">
          Theme Customizer
        </h4>
        <div class="theme-customizer-line"></div>
        <h6 class="mb-4 theme-customizer-subtitle">
          Customize & Preview in Real Time
        </h6>
        <slot></slot>
        <!-- slot content example -->
        <!--      <h5 class="mb-4 theme-customizer-topic-title">Inbox</h5>-->
        <!--      <ul class="list-unstyled mb-0">-->
        <!--        <li class="mb-4">-->
        <!--          <div class="mb-3">Layout Options</span>-->
        <!--          <div>content</div>-->
        <!--        </li>-->
        <!--        <li>-->
        <!--          <div class="mb-3">Delete Function</span>-->
        <!--          <div>content</div>-->
        <!--        </li>-->
        <!--      </ul>-->
        <!--      <div class="theme-customizer-line"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref
} from '@nuxtjs/composition-api'

export default defineComponent({
  setup(props, context) {
    const isShowThemeCustomizer = ref(false)
    const themeCustomizer = ref(null)

    function closeThemeCustomizer(e) {
      if (!themeCustomizer.value.contains(e.target)) {
        isShowThemeCustomizer.value = false
      }
    }

    onMounted(() => {
      window.addEventListener('click', closeThemeCustomizer)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('click', closeThemeCustomizer)
    })

    return {
      themeCustomizer,
      isShowThemeCustomizer
    }
  }
})
</script>
